import { useTranslation } from "react-i18next";
import { withForm } from "@/components/form/form";
import { PageSection } from "@/components/section/SectionBlocks";
import { ColorField, CountedTextareaField } from "./CompanyFields";
import { GUIDANCE_LIMIT, profileToForm } from "./companyForm";
import { LogoUpload } from "./LogoUpload";

const COLORS = [
  { name: "primary", key: "branding.primary" },
  { name: "secondary", key: "branding.secondary" },
  { name: "background", key: "branding.background" },
  { name: "textColor", key: "branding.text" },
] as const;

/** Export branding: logo, palette, fonts, tone, extra guidance. */
export const BrandingSection = withForm({
  defaultValues: profileToForm(null),
  props: {
    hasProfile: false,
    hasLogo: false,
    pendingLogo: null as File | null,
    onPendingLogo: (_file: File | null) => {},
  },
  render: function BrandingSectionRender({ form, hasProfile, hasLogo, pendingLogo, onPendingLogo }) {
    const { t } = useTranslation("adminCompany");
    return (
      <PageSection title={t("branding.title")} description={t("branding.description")}>
        <LogoUpload hasProfile={hasProfile} hasLogo={hasLogo} pending={pendingLogo} onPending={onPendingLogo} />
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {COLORS.map((color) => (
            <form.Field key={color.name} name={color.name}>
              {(field) => <ColorField field={field} label={t(color.key)} />}
            </form.Field>
          ))}
        </div>
        <form.AppField name="accents">
          {(field) => <field.TextField label={t("branding.accents")} placeholder={t("placeholders.accents")} />}
        </form.AppField>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <form.AppField name="headingFont">
            {(field) => (
              <field.TextField label={t("branding.headingFont")} placeholder={t("placeholders.headingFont")} />
            )}
          </form.AppField>
          <form.AppField name="bodyFont">
            {(field) => <field.TextField label={t("branding.bodyFont")} placeholder={t("placeholders.bodyFont")} />}
          </form.AppField>
        </div>
        <form.AppField name="tone">
          {(field) => <field.TextField label={t("branding.tone")} placeholder={t("placeholders.tone")} />}
        </form.AppField>
        <form.Field name="brandStyle">
          {(field) => (
            <CountedTextareaField
              field={field}
              label={t("branding.guidance")}
              limit={GUIDANCE_LIMIT}
              hint={t("branding.guidanceHint")}
              placeholder={t("placeholders.guidance")}
            />
          )}
        </form.Field>
      </PageSection>
    );
  },
});
